import React from 'react';

const AccountingAmount = ({ total }) => {
    const num = Number(total);

    // 1. Handle Zero Case (Accounting Dash)
    if (num === 0) {
        return (
            <div className="flex justify-between items-center w-full select-none">
                <span>$</span>
                {/* pr-[0.9em] centers the dash right where the decimal numbers normally sit */}
                <span className="text-right pr-[0.9em]">&mdash;</span>
            </div>
        );
    }

    // 2. Format the base absolute number
    const formatted = Math.abs(num).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    // 3. Render Positive or Negative Layouts
    return (
        <div className="flex justify-between items-center w-full">
            <span className="select-none">$</span>
            {num < 0 ? (
                // Negative: Sits flush against the right edge with parentheses
                <span className="text-right">({formatted})</span>
            ) : (
                // Positive: pr-[0.45em] reserves invisible space matching the width of the missing ")"
                <span className="text-right pr-[0.45em]">{formatted}</span>
            )}
        </div>
    );
};

export default AccountingAmount;
